module.exports = __webpack_public_path__ + "img/bitcoin.ca063397.png";